var render = function() {
  var _vm = this
  var _h = _vm.$createElement
  var _c = _vm._self._c || _h
  var l0 = _vm.__map(_vm.imgList, function(item, index) {
    var m0 = _vm.$getImg(item)
    return {
      $orig: _vm.__get_orig(item),
      m0: m0
    }
  })

  var g0 = _vm.commentObj.starLevel.toFixed(1)

  var m1 = require("static/hotel/tel.png")

  var m2 = require("static/traffic/go.png")

  var l1 = _vm.__map(_vm.roomList, function(item, __i1__) {
    var m3 = _vm.$getImg(item.image)
    return {
      $orig: _vm.__get_orig(item),
      m3: m3
    }
  })

  var m4 = require("static/hotel/shape.png")

  if (!_vm._isMounted) {
    _vm.e0 = function($event) {
      _vm.moreShow = !_vm.moreShow
    }
  }

  _vm.$mp.data = Object.assign(
    {},
    {
      $root: {
        l0: l0,
        g0: g0,
        m1: m1,
        m2: m2,
        l1: l1,
        m4: m4
      }
    }
  )
}
var staticRenderFns = []
render._withStripped = true

export { render, staticRenderFns }